import { Box } from '@mui/material'

const NotFound = () => {
  return <Box>Not Found</Box>
}
export default NotFound
